import Vue from "vue";
import dropdown from "./dropdown.vue";
import { currentLanguage, changeLanguage } from "./language-selection-helper.js"
import Cookies from "../../../javascripts/utils/cookies.js";
import { translationSupportedLanguages } from "../../utils/i18n.js";

document.addEventListener("DOMContentLoaded", () => {
  const cookieLocale = Cookies.get("locale");
  let language = cookieLocale;
  if (cookieLocale == undefined) {
    language = 'en';

    let navigatorLanguage = window.navigator.language;
    if (navigatorLanguage != undefined) {
      if (navigatorLanguage == "zh-CN") {
        navigatorLanguage = "zh-Hans";
      } else if (navigatorLanguage == "zh-TW") {
        navigatorLanguage = "zh-Hant";
      } else {
        navigatorLanguage = navigatorLanguage.split("-")[0];
      }
    }

    if (translationSupportedLanguages.includes(navigatorLanguage)) {
      language = navigatorLanguage;
    }
  }

  document.querySelectorAll(`[data-dropdown][name='select-language']`).forEach((el, i) => {
    new Vue({
      el: el,
      components: { dropdown },
      data: {
        id: `dropdown-${i + 1}`,
        name: el.attributes['name'].value,
        collection: el.getAttribute('data-collection'),
        collectionKeys: el.getAttribute('data-collection-keys').split(","),
        selectedFunc: currentLanguage(window, language),
        selectionFunc: changeLanguage(window),
      },
      template:
        `
          <dropdown
            :id=id
            :name=name
            :collection=collection
            :collectionKeys=collectionKeys
            :selectedFunc=selectedFunc
            :selectionFunc=selectionFunc>
          </dropdown>
        `
    });
  });
});
